import { Capacitor } from '@capacitor/core';

export const isIOS = () => {
  if (Capacitor.isNativePlatform()) return Capacitor.getPlatform() === 'ios';
  return /iPad|iPhone|iPod/.test(navigator.userAgent);
};

/**
 * Opens external navigation app (Google Maps / Apple Maps) for directions to a destination.
 */
export const openExternalNavigation = (lat: number, lon: number) => {
  if (isIOS()) {
    window.open(`maps://maps.apple.com/?daddr=${lat},${lon}`, '_system');
  } else {
    window.open(`https://www.google.com/maps/dir/?api=1&destination=${lat},${lon}`, '_system');
  }
};

/**
 * Opens external navigation with a full route (origin, destination, waypoints).
 */
export const openExternalRouteNavigation = (
  origin: { lat: number; lon: number },
  destination: { lat: number; lon: number },
  waypoints?: { lat: number; lon: number }[],
) => {
  const waypointStr = waypoints?.map(w => `${w.lat},${w.lon}`).join('|') || '';
  const url = `https://www.google.com/maps/dir/?api=1&origin=${origin.lat},${origin.lon}&destination=${destination.lat},${destination.lon}${waypointStr ? `&waypoints=${waypointStr}` : ''}&travelmode=driving`;
  window.open(url, '_system');
};
